import { lighten } from "@material-ui/core/styles/colorManipulator";
import { fade } from "@material-ui/core/styles/colorManipulator";
export const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(2)
  },
  style: {
    display: "none"
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
  },
  body: {
    fontSize: "14px",
    fontWeight: "400",
    padding: 0,
    cursor: 'pointer',
  },
  bodyCenter: {
    fontSize: "14px",
    fontWeight: "400",
    padding: 0,
    textAlign: "center"
  },
  icon: {
    fontSize: 40,
    float: "right",
    cursor: "pointer"
  },
  title1: {
    display: "inline-block",
    fontSize: 34,
    fontWeight: 500
  },
  tableCellEdit: {
    borderBottom: "none"
  },
  // modify
  tableRowHeight: {
    height: 0
  },
  button: {
    minWidth: 'max-content'
  },
  crownImageContainer:{
      // width:'30px',
      // height: '0px',
      textAlign: 'center'
  },
  crownImage:{
    // marginTop: '-15px'
    width: '24px'
  },
  tableCellInCollapes: {
    borderBottom: 'none'
  },
});

export const textFieldStyles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    // marginBottom: theme.spacing(1),
    padding: theme.spacing(3),
    // borderBottom: "1px solid rgba(224, 224, 224, 1)"
  },
  customFormLabel: {
    display: 'block',
    fontWeight: '500',
    fontSize: '0.75rem',
    color: '#292f48',
    marginBottom: theme.spacing(1),
  },
  padding24: {
    paddingRight: "24px !important"
  },
  menu: {
    width: "15%"
  },
  actives: {
    fontSize: 16,

    marginLeft: "60px",
    display: "inline-block"
  },
  button: {
    float: "right"
  },
  btnGGMap: {
    margin: "8px 0px 0px 0px"
  },
  switchBase: {
    "&$switchChecked": {
      color: theme.palette.common.white,
      "& + $switchBar": {
        backgroundColor: "#52d869"
      }
    },
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp
    })
  },
  switchChecked: {
    transform: "translateX(15px)",
    "& + $switchBar": {
      opacity: 1,
      border: "none"
    }
  },
  switchBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: "solid 1px",
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[500],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"])
  },
  switchIcon: {
    width: 24,
    height: 24
  },
  switchIconChecked: {
    boxShadow: theme.shadows[1]
  },
  containerMobile: {
    display: "flex"
  },
});
